import {
  handleCatchErrors,
  responseDataFormatRedux,
} from "../../middlewares/resolveRequests";

import {
  addSubAssignment,
  addSubTaskResponse,
  getAllSubTask,
  getAllSubTaskResponses,
  getSubAssignment,
  updateSubAssignment,
} from "../../services/SubPersidentalAssignment";
import * as actionTypes from "./actionTypes";

export const getAllSubAssignmentsAPI = async (taskId, token) => {
  let response;
  try {
    response = await getAllSubTask(taskId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(
      response,
      actionTypes.GET_ALL_SUB_ASSIGNMENTS,
    );
  }
};
export const addSubAssignmentAPI = async (data, token) => {
  let response;

  try {
    response = await addSubAssignment(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.ADD_SUB_ASSIGNMENT);
  }
};
export const updateSubAssignmentAPI = async (data, token) => {
  let response;

  try {
    response = await updateSubAssignment(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.UPDATE_SUB_ASSIGNMENT);
  }
};
export const getSubAssignmentAPI = async (id, token) => {
  let response;

  try {
    response = await getSubAssignment(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_SUB_ASSIGNMENT);
  }
};

export const getAllSubTaskResponsesAPI = async (id, token) => {
  let response;
  try {
    response = await getAllSubTaskResponses(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_ALL_SUB_COMMENTS);
  }
};
export const addSubTaskResponseAPI = async (
  owner,
  taskprocedureId,
  data,
  token,
) => {
  let response;

  try {
    response = await addSubTaskResponse(owner, taskprocedureId, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.ADD_SUB_COMMENT);
  }
};
